module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"carbonMap.title":"Region Overview","carbonMap.error.loadingRegions":"There was an issue loading your regions. If this problem persists please contact support.","carbonMap.error.loadingRegionTotals":"There was an issue loading your region spend. If this problem persists please contact support."}}')
  delete Component.options._Ctor
}
